import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [ // 发展团队移动端
    {
      path: '/nsale/',
      component: () => import('./views/Nsale/layout.vue'),
      children: [{
        path: '',
        redirect: '/nsale/team'
      },
      {
        path: 'team',
        name: 'team',
        component: () => {
            return import(/* webpackChunkName: "teamManage" */ './views/Nsale/teamM/teamManage.vue')
        }
      },
      {
        path: 'teamTemplate',
        name: 'teamTemplate',
        component: () => {
            return import(/* webpackChunkName: "teamTemplate" */ './views/Nsale/teamM/teamTemplate.vue')
        }
      },
      {
        path: 'detail/:id',
        meta: {
          edit: false
        },
        name: 'detail',
        component: () => {
            return import(/* webpackChunkName: "detail" */ './views/Nsale/teamM/edit_or_detail.vue')
        }
      },
      {
        path: 'cDetail/:id', // C端客户详情
        meta: {
          edit: false
        },
        name: 'cDetail',
        component: () => {
            return import(/* webpackChunkName: "cDetail" */ './views/Nsale/teamM/cUserDetail.vue')
        }
      },
      {
        path: 'edit/:id',
        meta: {
          edit: true,
          keepAlive: true
        },
        name: 'edit',
        component: () => {
            return import(/* webpackChunkName: "edit" */ './views/Nsale/teamM/edit_or_detail.vue')
        }
      },
      {
        path: 'list',
        name: 'list',
        component: () => {
            return import(/* webpackChunkName: "list" */ './views/Nsale/developT/list.vue')
        }
      },
      {
        path: 'preview/:id',
        meta: {
          edit: false,
          keepAlive: false
        },
        name: 'preview',
        component: () => {
            return import(/* webpackChunkName: "preview" */ './views/Nsale/developT/preView_or_edit.vue')
        }
      },
      {
        path: 'postEdit/:id',
        meta: {
          edit: true
        },
        name: 'postEdit',
        component: () => {
            return import(/* webpackChunkName: "postEdit" */ './views/Nsale/developT/preView_or_edit.vue')
        }
      },
      {
        path: 'listCUser', // C端邀请
        name: 'listCUser',
        component: () => {
            return import(/* webpackChunkName: "listCUser" */ './views/Nsale/developCUserT/list.vue')
        }
      },
      {
        path: 'previewCUser/:id', // C端邀请海报详情
        meta: {
          edit: false,
          keepAlive: false
        },
        name: 'previewCUser',
        component: () => {
            return import(/* webpackChunkName: "previewCUser" */ './views/Nsale/developCUserT/preView_or_edit.vue')
        }
      },
      {
        path: 'register/:id',
        name: 'NSaleInviteRegister',
        component: () => {
            return import(/* webpackChunkName: "NSaleInviteRegister" */ './views/Nsale/NSaleInviteRegister.vue')
        }
      },
      {
        path: 'pCenter',
        name: 'pCenter',
        component: () => { 
            return import(/* webpackChunkName: "pCenter" */ './views/Nsale/personCenter/pCenter.vue')
        }
      },
      {
        path: 'phone',
        name: 'phone',
        component: () => { 
            return import(/* webpackChunkName: "phone" */ './views/Nsale/personCenter/phone.vue')
        }
      },
      {
        path: 'verify',
        name: 'verify',
        component: () => { 
            return import(/* webpackChunkName: "verify" */ './views/Nsale/personCenter/verify.vue')
        }
      },
      {
        path: 'confirm/:smscode', // 邀请注册短信确认链接
        name: 'confirm-smscode-link',
        component: () => { 
            return import(/* webpackChunkName: "confirm-smscode-link" */ './views/Nsale/teamM/smsCodeConfirm.vue')
        }
      },
      {
        path: 'extension',
        name: 'extension',
        component: () => { 
            return import(/* webpackChunkName: "extension" */ './views/Nsale/teamM/extension.vue')
        }
      },
      {
        path: 'pdfView', // 预览pdf
        name: 'pdfView',
        component: () => { 
            return import(/* webpackChunkName: "pdfView" */ './components/pdfView.vue')
        }
      },
      {
        path: 'health', // 个人中心——健康服务
        name: 'health',
        component: () => { 
            return import(/* webpackChunkName: "health" */ './views/Nsale/healthService/healthService.vue')
        }
      }
      ]
    },
    // 【H5】AE邀请注册
    {
      path: '/invite/',
      component: () => import('./views/Nsale/register/layout.vue'),
      children: [{
        path: '',
        redirect: 'index'
      },
      {
        path: 'index',
        name: 'inviteIndex',
        component: () => { 
            return import(/* webpackChunkName: "inviteIndex" */ './views/Nsale/register/index.vue')
        }
      },
      {
        path: 'regist',
        name: 'regist',
        component: () => { 
            return import(/* webpackChunkName: "regist" */ './views/Nsale/register/regist.vue')
        }
      },
      {
        path: 'upload',
        name: 'upload',
        component: () => { 
            return import(/* webpackChunkName: "upload" */ './views/Nsale/register/upload.vue')
        }
      },
      {
        path: 'loginInfo',
        name: 'loginInfo',
        component: () => { 
            return import(/* webpackChunkName: "loginInfo" */ './views/Nsale/register/loginInfo.vue')
        }
      },
      {
        path: 'success',
        name: 'inviteSuccess',
        component: () => { 
            return import(/* webpackChunkName: "inviteSuccess" */ './views/Nsale/register/success.vue')
        }
      }
      ]
    },
    // 新蜂-my客蜂
    {
      path: '/newbee/',
      component: () => import('./views/newbee/layout.vue'),
      children: [{
        path: '',
        redirect: 'list'
      },
      {
        path: 'demo',
        name: 'demo',
        component: () => { 
            return import(/* webpackChunkName: "demo" */ './views/newbee/sharePoster/demo.vue')
        }
      },
      {
        path: 'list',
        name: 'myBeelist',
        component: () => { 
            return import(/* webpackChunkName: "myBeelist" */ './views/newbee/sharePoster/list.vue')
        }
      },
      {
        path: 'preview',
        meta: {
          edit: false,
          keepAlive: false
        },
        name: 'myBeePreview',
        component: () => { 
            return import(/* webpackChunkName: "myBeePreview" */ './views/newbee/sharePoster/preView_or_edit.vue')
        }
      },
      {
        path: 'postEdit',
        meta: {
          edit: true
        },
        name: 'myBeePostEdit',
        component: () => import(/* webpackChunkName: "myBeePostEdit" */ './views/newbee/sharePoster/preView_or_edit.vue')
      }
      ]
    },
    {
      path: '/bs/',
      component: () => import('./views/Nsale/Bs/index.vue'),
      children: [
      {
        path: 'my-team/member-list',
        name: 'memberList',
        component: () => {
            return import('./views/Nsale/Bs/my-team/member-list.vue')
        }
      },
      {
        path: 'my-team/add-member',
        name: 'addMember',
        component: () => {
            return import('./views/Nsale/Bs/my-team/add-member.vue')
        }
      },
      {
        path: 'productShare',
        name: 'productShare',
        component: () => {
            return import('./views/Nsale/Bs/productShare.vue')
        }
      }, {
        path: 'productPromote',
        name: 'productPromote',
        component: () => {
            return import(/* webpackChunkName: "productPromote" */ './views/Nsale/Bs/productPromote.vue')
        }
      },
      {
        path: 'productCommon',
        name: 'productCommon',
        component: () => {
            return import(/* webpackChunkName: "productCommon" */ './views/Nsale/Bs/productCommon.vue')
        }
      },
      {
        path: 'article',
        name: 'article',
        component: () => {
            return import(/* webpackChunkName: "article" */  './views/Nsale/Bs/article.vue')
        }
      },
      {
        path: 'customerNotification',
        name: 'customerNotification',
        component: () => {
            return import(/* webpackChunkName: "customerNotification" */ './views/Nsale/Bs/customerNotification.vue')
        }
      },
      {
        path: 'extension',
        name: 'extension',
        component: () => {
            return import(/* webpackChunkName: "extension" */ './views/Nsale/Bs/extension.vue')
        }
      },
      {
        path: 'myCombinations',
        name: 'myCombinations',
        component: () => {
            return import(/* webpackChunkName: "myCombinations" */ './views/Nsale/Bs/myCombinations.vue')
        }
      },
      {
        path: 'authentication',
        name: 'authentication',
        component: () => {
            return import(/* webpackChunkName: "authentication" */ './views/Nsale/Bs/authentication.vue')
        }
      },
      { // 我的保单
        path: 'mypolicy',
        name: 'mypolicy',
        component: () => {
            return import(/* webpackChunkName: "mypolicy" */ './views/Nsale/Bs/mypolicy.vue')
        }
      },
      { // 我的保单详情
        path: 'mypolicydetail',
        name: 'mypolicydetail',
        component: () => {
            return import(/* webpackChunkName: "mypolicy" */ './views/Nsale/Bs/mypolicydetail.vue')
        }
      },
      { // 体检卡详情
        path: 'physicalcarddetail',
        name: 'physicalcarddetail',
        component: () => {
            return import(/* webpackChunkName: "mypolicy" */ './views/Nsale/Bs/physicalcarddetail.vue')
        }
      },
      { // 风险告知函提交
        path: 'risk',
        name: 'risk',
        component: () => {
            return import(/* webpackChunkName: "risk" */ './views/Nsale/Bs/risk/index.vue')
        }
      },
      { // 风险告知函详情
        path: 'risk-detail',
        name: 'riskDetail',
        component: () => {
            return import(/* webpackChunkName: "risk" */ './views/Nsale/Bs/risk/detail.vue')
        }
      },
      {
        path: 'authpage',
        name: 'authpage',
        component: () => {
            return import(/* webpackChunkName: "authpage" */ './views/Nsale/Bs/authpage.vue')
        }
      },
      {
        path: 'authResult',
        name: 'authResult',
        component: () => {
            return import(/* webpackChunkName: "authpage" */ './views/Nsale/Bs/authResult.vue')
        }
      },
      {
        path: 'PCPolicyGuide',
        name: 'PCPolicyGuide',
        component: () => {
            return import(/* webpackChunkName: "mypolicy" */ './views/Nsale/Bs/PCPolicyGuide.vue')
        }
      },
      {
        path: 'renewal',
        name: 'renewal',
        component: () => {
            return import(/* webpackChunkName: "renewal" */ './views/Nsale/Bs/renewal.vue')
        }
      },
      {
        path: 'policyDetail',
        name: 'policyDetail',
        component: () => {
            return import(/* webpackChunkName: "policyDetail" */ './views/Nsale/Bs/policyDetail.vue')
        }
      },
      {
        path: 'pastRenewal',
        name: 'pastRenewal',
        component: () => {
            return import(/* webpackChunkName: "pastRenewal" */ './views/Nsale/Bs/pastRenewal.vue')
        }
      },
      {
        path: 'order',
        name: 'order',
        component: () => {
            return import(/* webpackChunkName: "order" */ './views/Nsale/Bs/order.vue')
        }
      },
      {
        path: 'myjfinprogress',
        name: 'myjfinprogress',
        component: () => {
            return import(/* webpackChunkName: "myjfinprogress" */ './views/Nsale/Bs/myjfinprogress.vue')
        }
      },
      {
        path: 'withdrawncash',
        name: 'withdrawncash',
        component: () => {
            return import(/* webpackChunkName: "withdrawncash" */ './views/Nsale/Bs/withdrawncash.vue')
        }
      },
      {
        path: 'withdrawdetail',
        name: 'withdrawdetail',
        component: () => {
            return import(/* webpackChunkName: "withdrawncash" */ './views/Nsale/Bs/withdrawdetail.vue')
        }
      },
      {
        path: 'withdrawalamount',
        name: 'withdrawalamount',
        component: () => {
            return import(/* webpackChunkName: "withdrawncash" */ './views/Nsale/Bs/withdrawalamount.vue')
        }
      },
      {
        path: 'withdrawscore',
        name: 'withdrawscore',
        component: () => {
            return import(/* webpackChunkName: "withdrawncash" */ './views/Nsale/Bs/withdrawscore.vue')
        }
      },
      {
        path: 'withdrawresult',
        name: 'withdrawresult',
        component: () => {
            return import(/* webpackChunkName: "withdrawncash" */ './views/Nsale/Bs/withdrawresult.vue')
        }
      },
      {
        path: 'canWithdraw',
        name: 'canWithdraw',
        component: () => {
            return import(/* webpackChunkName: "withdrawncash" */ './views/Nsale/Bs/canWithdraw.vue')
        }
      },
      {
        path: 'jfrule',
        name: 'jfrule',
        component: () => {
            return import(/* webpackChunkName: "jfrule" */ './views/Nsale/Bs/jfrule.vue')
        }
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => {
            return import(/* webpackChunkName: "orderDetail" */ './views/Nsale/Bs/orderDetail.vue')
        }
      },
      {
        path: '/activity',
        name: 'activity',
        component: () => {
            return import(/* webpackChunkName: "activity" */ './views/Nsale/Bs/activity/index.vue')
        }
      },
      {
        path: '/activity/detail',
        name: 'activityDetail',
        component: () => {
            return import(/* webpackChunkName: "activity" */ './views/Nsale/Bs/activity/detail.vue')
        }
      },
      {
        path: 'privacyAgreement',
        name: 'privacyAgreement',
        component: () => {
            return import(/* webpackChunkName: "privacyAgreement" */ './views/Nsale/Bs/privacyAgreement/index.vue')
        }
      },
			// 协议签署
      {
        path: 'agreementSign',
        name: 'agreementSign',
        component: () => { 
            return import(/* webpackChunkName: "agreementSign" */ './views/Nsale/Bs/agreementSign.vue')
        }
      },
			// 协议签署告知-企业
      {
        path: 'agreementNotices',
        name: 'agreementNotices',
        component: () => { 
            return import(/* webpackChunkName: "agreementSign" */ './views/Nsale/Bs/agreementNotices.vue')
        }
      },
			// 协议签署-结果查询页
      {
        path: 'agreementSignResult',
        name: 'agreementSignResult',
        component: () => { 
            return import(/* webpackChunkName: "agreementSignResult" */ './views/Nsale/Bs/agreementSignResult.vue')
        }
      },
			// 协议签署-文件列表
      {
        path: 'agreementList',
        name: 'agreementList',
        component: () => { 
            return import(/* webpackChunkName: "agreementList" */ './views/Nsale/Bs/agreementList.vue')
        }
      },
      // 宇泰云服
      {
        path: '/productDetail',
        name: 'product-detail',
        component: () => { 
            return import(/* webpackChunkName: "ytyf" */ './views/yf/productDetail')
        }
      },
      { // 短险预约
        path: '/productAppointmentShort',
        name: 'productAppointmentShort',
        component: () => { 
            return import(/* webpackChunkName: "ytyf" */ './views/yf/productAppointmentShort')
        }
      },
      { // 长险预约
        path: '/productAppointment',
        name: 'productAppointment',
        component: () => { 
            return import(/* webpackChunkName: "ytyf" */ './views/yf/productAppointment.vue')
        }
      },
      {
        path: '/productAppointmentSuccess',
        name: 'productAppointmentSuccess',
        component: () => { 
            return import(/* webpackChunkName: "ytyf" */ './views/yf/productAppointmentSuccess.vue')
        }
      },
      {
        path: '/materialContent',
        name: 'materialContent',
        component: () => { 
            return import(/* webpackChunkName: "ytyf" */ './views/yf/materialContent.vue')
        }
      },
      {
        path: '/yf/privacyAgreement',
        name: 'yfprivacyAgreement',
        component: () => { 
            return import(/* webpackChunkName: "ytyf" */ './views/yf/privacyAgreement/index.vue')
        }
      },
      ]
    }
  ]
})
